exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/object-get-own-property-symbols.js
// module id = fTzd
// module chunks = 0